export type Severity = 'unclassified' | 'information' | 'warning' | 'error';
export enum SeverityEnum {
	INFORMATION = 'information',
	WARNING = 'warning',
	ERROR = 'error',
	UNClASSIFIED = 'unclassified',
}

interface MessageDraftI {
	severity?: Severity;
	title?: string;
	message: string | Error;
	icon?: string;
}

export class GlobalMessage {
	public readonly severity: Severity;
	public readonly title: string;
	public readonly message: string;
	public readonly icon?: string;
	public readonly timestamp: Date;

	constructor({ severity = 'unclassified', title = '', message, icon = '' }: MessageDraftI) {
		this.severity = severity;
		this.title = title;
		if (message instanceof Error) message = message.message;
		this.message = message;
		if (!icon) {
			if (severity === SeverityEnum.UNClASSIFIED) this.icon = 'mdi-progress-alert';
			if (severity === SeverityEnum.INFORMATION) this.icon = 'mdi-information-outline';
			if (severity === SeverityEnum.WARNING) this.icon = 'mdi-alert-box-outline';
			if (severity === SeverityEnum.ERROR) this.icon = 'mdi-alert-circle-outline';
		} else {
			this.icon = icon;
		}
		this.timestamp = new Date();
	}

	public isEqual(otherMessage: GlobalMessage) {
		return (
			this.severity === otherMessage.severity &&
			this.title === otherMessage.title &&
			this.message === otherMessage.message &&
			this.icon === otherMessage.icon
		);
	}
}
